export enum Errors {
  UnknownError = 'UnknownError',
  ServerError = 'ServerError',
  PasswordTooWeak = 'PasswordTooWeak',
  InvalidEmailAddressError = 'Invalid email address',
  PasswordsDoNotMatchError = 'Passwords do not match',
  MissingResetHashInPayload = 'MissingResetHash',
  HashInvalidOrExpired = 'HashInvalidOrExpired',
  VerificationUnsuccessful = 'VerificationUnsuccessful',
  VerficationMissingHash = 'VerificationMissingHash',
  InvalidEmailPasswordCombo = 'InvalidEmailPasswordCombo',
}
